<template>
    <main>
        <vue-headful title="ABL Groupe | Bjorneborg Steel" />
        <div class="container">
            <img class="banner-img" :src="require('../../assets/images/bjorneborg.png')"/>
            <h2>Björneborg Steel</h2>
            <section class="forge--box">
                <div class="forge--titles">
                    <h3>Pièces ébauchées ou usinées
                        <p>Rough machined or finished parts</p>
                    </h3>
                    <h3>Programme de fabrication
                        <p>Production Range</p>
                    </h3>
                </div>
                <h3 class="sub-title">Aciers carbone, aciers faiblement alliés , CR - MI - MO , aciers à outils</h3>

                <div class="forge--items">
                    <div class="forge--item col-sm-3 col-xs-12">
                        <p>Arbres<span>/Shafts</span></p>
                        <p>Ronds<span>/Round bars </span></p>
                        <div class="forge--item-text">
                            <p>ø max : 1300mm</p>
                            <p>L max : 24000mm</p>
                            <p>Poids max / weight : 40 t</p>
                        </div>
                    </div>
                    <div class="forge--item col-sm-3 col-xs-12">
                        <p>Blocs<span>/Blocks</span></p>
                        <p>Plaques<span>/Plates</span></p>
                        <div class="forge--item-text">
                            <p>h : 2000 mm</p>
                            <p>l : 1200 mm</p>
                            <p>L max : 15000 mm</p>
                            <p>Poids max / weight : 30 t</p>
                        </div>
                    </div>
                    <div class="forge--item col-sm-3 col-xs-12">
                        <p>Disques<span>/Discs</span></p>
                        <p>Anneaux<span>/Rings </span></p>
                        <div class="forge--item-text">
                            <p>ø max : 2400 mm</p>
                            <p>Poids max / weight : 20 t</p>
                        </div>
                    </div>
                </div>
                <div class="forge--items">
                    <div class="forge--item col-sm-3 col-xs-12">
                        <p>Tubes<span>/Pipes</span></p>
                        <p>Arbres creux<span>/Hollow Shafts</span></p>
                        <div class="forge--item-text">
                            <p>ø max : 1500 mm</p>
                            <p>Ep. min / wall thickness : 70 mm</p>
                            <p>Poids max / weight : 30 t</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </main>

</template>

<script>
    export default {
        name: "BjorneborgSteelFreeForge"
    }
</script>

<style scoped>
    .sub-title {
        text-align: center;
    }

    .forge--items {
        text-align: center;
        justify-content: space-around;
    }

    .banner-img {
        width: 100%;
        margin-top: -50px;
        margin-bottom: 10px;
    }
</style>